import { IValidateVerificationCodeOutput } from '@core-ports/outputs/auth';
import type { IUser } from '@core-ports/outputs/user';
import { gql } from 'apollo-angular';
import { userGraphqlSchema } from './schemas/user';

export const mutation_create_user = gql`
mutation User($input: CreateUserInput!) {
	createUser(input: $input) {
	${userGraphqlSchema}
	}
}
`;

export interface IMutationCreateUserOutput {
  createUser: IUser;
}

export const mutation_generate_verification_code = gql`
mutation User($email: String!, $os: String) {
	generateCode(
		email: $email,
		os: $os
	)
}
`;

export interface IMutationGenerateVerificationCodeOutput {
  generateCode: boolean;
}

export const mutation_validate_verification_code = gql`
mutation User($email: String!, $otp_code: String!) {
	validateCode(email: $email, otp_code: $otp_code) {
		token
		refresh_token
	}
}
`;

export interface IMutationValidateVerificationCodeOutput {
  validateCode: IValidateVerificationCodeOutput;
}

export const mutation_refresh_token = gql`
mutation RefreshToken($refresh_token: String!) {
	refreshToken(refresh_token: $refresh_token) {
		token
		refresh_token
	}
}
`;

export interface IMutationRefreshTokenOutput {
  refreshToken: IValidateVerificationCodeOutput;
}
